export default "__VITE_ASSET__2d4a1ae9__"